var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RollupFunction } from '@logz-pkg/enums';
import { Expose } from 'class-transformer';
export class RollupRuleModel {
    id;
    name;
    accountId;
    metricName;
    metricType = 'COUNTER';
    rollupFunction = RollupFunction.SUM;
    labelsEliminationMethod = 'EXCLUDE_BY';
    labels;
    filter;
    dropOriginalMetric = true;
    newMetricNameTemplate;
    accountName;
}
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", String)
], RollupRuleModel.prototype, "id", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", String)
], RollupRuleModel.prototype, "accountName", void 0);
//# sourceMappingURL=rollup-rule.js.map